import { fetchNormalDocuments, fetchDeleted } from 'api/documents'
import { DEFAULT_PER_PAGE, LOCAL_STORAGE_KEYS, MODE } from 'config'
import { redirect, useRouteLoaderData } from 'react-router-dom'

import { SearchParams } from './Search/Search'

type DocumentListSearchParams = {
  page: string
  perPage: string
} & SearchParams

const INIT_SEARCH_PARAMS: DocumentListSearchParams = {
  name: '',
  docTypeName: '',
  status: '',
  updateDateFrom: null,
  updateDateTo: null,
  updateUserName: '',
  assigneeName: '',
  subGroup: '',
  verifyStatus: 0,
  page: '',
  perPage: '',
}

export default async function loader({ request, params }, isDeleted = false) {
  const url = new URL(request.url)
  const urlSearchParams = Object.fromEntries(url.searchParams)

  const localStoragePerPage =
    localStorage.getItem(LOCAL_STORAGE_KEYS.documentListPerPage) ||
    String(DEFAULT_PER_PAGE)

  const searchParams: DocumentListSearchParams = {
    ...INIT_SEARCH_PARAMS,
    ...urlSearchParams,
    ...{ perPage: localStoragePerPage },
  }
  const { docInfoList, total } = isDeleted
    ? await fetchDeleted(searchParams, params.mode === MODE.VERIFY)
    : await fetchNormalDocuments(searchParams)
  const page = parseInt(searchParams.page) || 0
  const perPage = parseInt(searchParams.perPage)
  if (searchParams.page && page !== 0 && page * perPage >= total) {
    url.searchParams.set(
      'page',
      String(total === 0 ? 0 : Math.ceil(total / perPage) - 1),
    )
    return redirect('.?' + url.searchParams.toString()) // eslint-disable-line prefer-template
  }
  return { documents: docInfoList, total, params: searchParams }
}

export function useHomeLoaderData() {
  return useRouteLoaderData('home') as Exclude<
    Awaited<ReturnType<typeof loader>>,
    Response
  >
}
